import { createMedia } from '@artsy/fresnel';

const RaiderIOMedia = createMedia({
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1280
  }
});

const RaiderIOMediaV2 = createMedia({
  breakpoints: {
    xs: 0,
    sm: 480,
    smm: 600,
    md: 768,
    lg: 1024,
    xl: 1280
  }
});

// Generate CSS to be injected into the head
export const mediaStyle = RaiderIOMedia.createMediaStyle();
export const mediaStyleV2 = RaiderIOMediaV2.createMediaStyle();
export const { Media, MediaContextProvider } = RaiderIOMedia;
export const { Media: MediaV2, MediaContextProvider: MediaContextProviderV2 } = RaiderIOMediaV2;
